function selectBreadcrumbs() {
    let $selectBreadcrumbs = $('.js-select-breadcrumbs'),
        $selectBreadcrumbsInp = $selectBreadcrumbs.find('select');

    $selectBreadcrumbsInp.niceSelect();
}

export default selectBreadcrumbs;